import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { bailiffDocumentDetailSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

export const FLOWS = {
  LOCKED: "locked",
  PAID: "paid",
  LOADING: "loading",
};

export const useFlow = () => {
  // -------------------------- VAR -----------------------------
  const [flow, setFlow] = useState(FLOWS.LOADING);

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffDocumentDetailSelector);
  const status = detail?.status || null;
  const downloadedAt = detail?.downloadedAt || null;
  const deletingAt = detail?.deletingAt || null;
  const mDonwload = moment(downloadedAt?.toDate()).add(1, "days");
  const mDeleteAt = moment(deletingAt?.toDate()).add(10, "minutes");

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (!status) {
      setFlow(FLOWS.LOADING);
    }
    if (status) {
      const valid2 =
        status === "downloaded" && moment()?.diff(mDonwload, "second") < 0;
      const valid3 =
        status === "deleting" && moment()?.diff(mDeleteAt, "second") < 0;
      if (status === "ready for download") {
        setFlow(FLOWS.PAID);
      } else if (valid2) {
        setFlow(FLOWS.PAID);
      } else if (valid3) {
        setFlow(FLOWS.PAID);
      } else {
        setFlow(FLOWS.LOCKED);
      }
    }
  }, [status, downloadedAt, deletingAt, mDonwload, mDeleteAt]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
